<template>
<div class="wrap">
  <div class="lyDim" style="z-index:9999"></div>
  <section class="layerPop layerPopCustom">
    <div class="lyWrap">

      <h1 class="lyTit lyTitCustom">
        Service Care+ 멤버십<br>
        가격 변경 안내
      </h1>

      <div class="lyCon lyDate">
        2023년 1월 2일부터
      </div>
      
      <div class="lyCon lyConCustom lyContent">
        서비스케어 플러스를 사랑해주시는<br>
        고객님께 감사의 말씀을 드립니다.<br>
        <br>
        원자재, 물류비, 인건비 등의<br>
        지속적인 상승으로 인해 부득이하게<br>
        <span style="color:#0068DC;">2023년 1월 2일부로 가격을 조정</span>하게 되었습니다.<br>
        <br>
        고객 여러분의 양해 부탁드립니다.<br>
        항상 고객님께 최고 품질의 서비스를 제공할 수<br>
        있도록 노력하겠습니다.<br>
      </div>
      
      <div class="btnBox">
        <span><a class="btnWL" @click="close(24)">오늘하루 보지 않기</a></span>
        <span><a class="btnWR" @click="close()">닫기</a></span>
      </div>

    </div>
  </section>
</div>
</template>


<script>
import ButtonSubscApply from "../Button/ButtonSubscApply";
export default {
  components: {ButtonSubscApply},

  data(){
    return{
    }
  },
  methods: {
    close(time){
      if (time){
        localStorage.setItem('NoticeClosed', Date.now().toString());
      }
      this.$emit('close');
    }
  }
}
</script>

<style lang="css" scoped>
.layerPopCustom{
  display: block; 
  z-index:9999;
  width:100%;
  max-width:600px;
  top:50%; left:50%;
  transform: translate(-50%, -50%);
}

.lyConCustom{
  /*noinspection CssUnresolvedCustomProperty*/
  max-height:calc((var(--vh, 1vh) * 100) - 225px);
  text-align: center;
}

.lyTitCustom{
  font-size: 19px;
  font-weight: bolder;
  line-height: 24px;
  position: relative;
  color: #262626
}

.lyContent{
  font-size: 14px;
  line-height: 1.6em;
  margin: 20px auto;
  color: #262626
}

.lyDate{
  flex-direction: row;
  padding: 20px 30px;
  margin: 0 20px;
  gap: 10px;
  font-size: 16px;
  font-weight: bolder;
  text-align: center;
  align-items: center;
  line-height: 20px;

  background: #F4F4F4;
  color: #262626;
}
</style>